<form
  svcTestId="ap-form__section--form"
  [formGroup]="formActionPlan"
  class="py-4 grid grid-cols-4 gap-4"
  [ngClass]="{ 'opacity-60': isAllCombosLoading }"
>
  <div svcTestId="ap-form__section--description" class="col-span-full ap-form-description-row">
    <svc-audio-to-text-wrapper
      class="w-full"
      customClass="items-center"
      [control]="formActionPlan.controls.description"
      [shadow]="false"
      [showVoiceToTextButton]="showVoiceToTextButton && (isAddMode || isEditMode)"
    >
      <svc-text
        svcTestId="ap-form__input--title"
        inputId="action-plan-register-form-description"
        class="w-full"
        formControlName="description"
        [maxLength]="150"
        [label]="'Plano de ação' | transloco"
        [readonly]="!isAddMode && !isEditMode"
      ></svc-text>
    </svc-audio-to-text-wrapper>
  </div>

  <div svcTestId="ap-form__section--meta" class="grid col-span-full grid-cols-2 sm:grid-cols-4 gap-4">
    <div svcTestId="ap-form__label--number" class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
      <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Número' | transloco }}</span>
      <span class="text-base font-bold">{{ actionPlanNumber }}</span>
    </div>

    <div svcTestId="ap-form__label--status" class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
      <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Status' | transloco }}</span>
      <div class="text-base">
        @if (hasStatusTag) {
          <svc-status-badge
            [badgeData]="{
              description: statusLabelById[currentStatusId] | transloco,
              type: statusTypeById[currentStatusId],
            }"
          ></svc-status-badge>
        } @else {
          <span>-</span>
        }
      </div>
    </div>

    @if (!isAddMode && !isEditMode) {
      <div class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
        <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Tipo' | transloco }}</span>
        <p class="font-medium text-base text-default mb-3 m-0">
          {{ selectedTypeLabel }}
        </p>
      </div>
    } @else {
      <svc-chip
        svcTestId="ap-form__select--type"
        class="sm:col-span-1 h-fit"
        inputId="action-plan-register-form-type"
        formControlName="typeId"
        type="single"
        [label]="'Tipo' | transloco"
        [options]="optionsCombos?.types"
        [loading]="isAllCombosLoading"
        [readonly]="!isAddMode && !isEditMode"
        [truncateTextValue]="true"
      ></svc-chip>
    }

    @if (!isAddMode && !isEditMode) {
      <div class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
        <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Prioridade' | transloco }}</span>
        <p class="font-medium text-base text-default mb-3 m-0 break-words">
          {{ selectedPriorityLabel }}
        </p>
      </div>
    } @else {
      <svc-chip
        svcTestId="ap-form__select--priority"
        class="sm:col-span-1 h-fit"
        inputId="action-plan-register-form-priority"
        formControlName="priorityId"
        type="single"
        [label]="'Prioridade' | transloco"
        [options]="optionsCombos?.priorities"
        [loading]="isAllCombosLoading"
        [readonly]="!isAddMode && !isEditMode"
        [truncateTextValue]="true"
      >
        <ng-template let-option="option">
          <span
            class="action-plan-priority-option-label"
            [attr.title]="option?.label ?? ''"
          >
            {{ option?.label }}
          </span>
        </ng-template>
      </svc-chip>
    }
  </div>

  <div svcTestId="ap-form__section--classification" class="grid col-span-full grid-cols-1 sm:grid-cols-4 gap-4">
    @if (!isAddMode && !isEditMode) {
      <div class="ap-form-label-gap sm:col-span-2 flex flex-col gap-[8px]">
        <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Sistema' | transloco }}</span>
        <p class="font-medium text-base text-default mb-3 m-0">
          {{ selectedSystemLabel }}
        </p>
      </div>
    } @else {
      <svc-chip
        svcTestId="ap-form__select--system"
        class="sm:col-span-2 h-fit"
        inputId="action-plan-register-form-system"
        formControlName="systemId"
        type="single"
        [label]="'Sistema' | transloco"
        [options]="optionsCombos?.systems"
        [loading]="isAllCombosLoading"
        [readonly]="!isAddMode && !isEditMode"
        [truncateTextValue]="true"
        (onSelectChanged)="onSystemSelectChanged($event)"
      ></svc-chip>
    }

    <div class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
      <span class="inline-flex input-label-size input-label-weight text-default">{{ 'Fonte' | transloco }}</span>
      <div class="text-base">
        @if (showSourceLink && canOpenSourceLink) {
          <button
            svcTestId="ap-form__btn--source-link"
            type="button"
            class="text-primary font-bold underline text-left hover:opacity-80"
            (click)="openSourceLink()"
          >
            {{ sourceLabel }}
          </button>
        } @else {
          <span>{{ sourceLabel }}</span>
        }
      </div>
    </div>

    <div class="ap-form-label-gap sm:col-span-1 flex flex-col gap-[8px]">
      <span class="inline-flex input-label-size input-label-weight text-default">{{ reprogrammingFieldLabel }}</span>
      <div class="text-base">
        <span>{{ reprogrammingLabel }}</span>
      </div>
    </div>
  </div>

  <div svcTestId="ap-form__section--people" class="grid col-span-full grid-cols-1 sm:grid-cols-4 gap-4">
    @if (!isEditMode) {
      <div class="ap-form-label-gap sm:col-span-2 flex flex-col gap-[8px]">
        <p class="inline-flex input-label-size input-label-weight text-default m-0">
          {{ 'Originador' | transloco }}
        </p>

        <div class="flex gap-2">
          <svc-smart-user-avatar
            [ids]="formActionPlan?.controls?.originatorId?.value?.[0]"
            [size]="24"
          ></svc-smart-user-avatar>

          @if (originatorName) {
            <p class="text-default text-base font-medium m-0">
              {{ originatorName }}
            </p>
          }
        </div>
      </div>
    } @else {
      <svc-chip
        svcTestId="ap-form__select--originator"
        class="sm:col-span-2 h-fit"
        inputId="action-plan-register-form-originator"
        formControlName="originatorId"
        type="single"
        [label]="'Originador' | transloco"
        [options]="usersOptions"
        [loading]="isAllCombosLoading"
        [readonly]="!canEditOriginator"
        [truncateTextValue]="true"
      >
        <ng-template let-option="option">
          <div class="flex items-center gap-2 min-w-0">
            <svc-smart-user-avatar
              [ids]="option?.value"
              [size]="20"
            ></svc-smart-user-avatar>
            <span class="truncate">{{ option?.label }}</span>
          </div>
        </ng-template>
      </svc-chip>
    }

    @if (!isAddMode && !isEditMode) {
      <div class="ap-form-label-gap sm:col-span-2 flex flex-col gap-[8px]">
        <p class="inline-flex input-label-size input-label-weight text-default m-0">
          {{ 'Responsável' | transloco }}
        </p>

        <div class="flex gap-2 items-center">
          @if (selectedResponsibleId) {
            <svc-smart-user-avatar
              [ids]="selectedResponsibleId"
              [size]="24"
            ></svc-smart-user-avatar>
          }

          <p class="text-default text-base font-medium m-0">
            {{ selectedResponsibleLabel }}
          </p>
        </div>
      </div>
    } @else {
      <svc-chip
        svcTestId="ap-form__select--responsible"
        class="sm:col-span-2 h-fit"
        inputId="action-plan-register-form-responsible"
        formControlName="responsibleId"
        type="single"
        [label]="'Responsável' | transloco"
        [options]="usersOptions"
        [loading]="isAllCombosLoading"
        [readonly]="!isAddMode && !isEditMode"
        [readonlyStyle]="'transparent-chip'"
        [truncateTextValue]="true"
      >
        <ng-template let-option="option">
          <div class="flex items-center gap-2 min-w-0">
            <svc-smart-user-avatar
              [ids]="option?.value"
              [size]="20"
            ></svc-smart-user-avatar>
            <span class="truncate">{{ option?.label }}</span>
          </div>
        </ng-template>
      </svc-chip>
    }
  </div>

  <div svcTestId="ap-form__section--actors" class="grid col-span-full grid-cols-1 sm:grid-cols-4 gap-4 items-end">
    @if (!isAddMode && !isEditMode) {
      <div class="ap-form-label-gap sm:col-span-3 flex flex-col gap-[8px]">
        <p class="inline-flex input-label-size input-label-weight text-default m-0">
          {{ 'Atores' | transloco }}
        </p>

        <div class="flex flex-wrap gap-2">
          @if (selectedActorIds.length) {
            @for (actorId of selectedActorIds; track actorId; let actorIndex = $index) {
              <div class="flex items-center gap-2">
                @if (isActorTeamValue(actorId)) {
                  <mat-icon
                    class="icon-size-6 text-default"
                    svgIcon="heroicons_solid:user-group"
                  ></mat-icon>
                } @else {
                  <svc-smart-user-avatar
                    [ids]="getActorRawId(actorId)"
                    [size]="24"
                  ></svc-smart-user-avatar>
                }
                <span class="text-default text-base font-medium">
                  {{ selectedActorLabels[actorIndex] || '-' }}
                </span>
              </div>
            }
          } @else {
            <span class="text-base">-</span>
          }
        </div>
      </div>
    } @else {
      <svc-chip-grouped
        svcTestId="ap-form__multiselect--actors"
        class="sm:col-span-3 h-fit"
        inputId="action-plan-register-form-actors"
        formControlName="actors"
        type="multiple"
        [placeholder]="'Opcional' | transloco"
        [label]="'Atores' | transloco"
        [options]="ownersOptions"
        [loading]="isAllCombosLoading"
        [readonly]="!isAddMode && !isEditMode"
        [readonlyStyle]="'transparent-chip'"
        [truncateTextValue]="true"
      >
        <ng-template let-option="option">
          <div class="flex items-center gap-2 min-w-0">
            @if (isActorTeamValue(option?.value)) {
              <mat-icon
                class="icon-size-5 text-default"
                svgIcon="heroicons_solid:user-group"
              ></mat-icon>
            } @else {
              <svc-smart-user-avatar
                [ids]="getActorRawId(option?.value)"
                [size]="20"
              ></svc-smart-user-avatar>
            }
            <span class="truncate">{{ option?.label }}</span>
          </div>
        </ng-template>
      </svc-chip-grouped>
    }

    <svc-slide-toggle
      svcTestId="ap-form__toggle--confidential"
      class="sm:col-span-1 action-plan-confidential-toggle text-default flex items-center gap-2"
      inputId="action-plan-register-form-confidential"
      formControlName="confidential"
    >
      <span class="font-semibold text-default">{{ 'Confidencial' | transloco }}</span>
    </svc-slide-toggle>
  </div>

  @if (selectedSystemUniqueId && (isResolvingCustomFieldsTemplate || shouldShowCustomFields)) {
    @if (isResolvingCustomFieldsTemplate) {
      <div svcTestId="ap-form__section--custom-fields-skeleton" class="col-span-full grid grid-cols-1 sm:grid-cols-2 gap-4">
        @for (skeleton of [1, 2]; track $index) {
          <div class="flex flex-col gap-2">
            <ngx-skeleton-loader class="h-[18px]" [theme]="{ width: '32px', height: '18px' }"></ngx-skeleton-loader>
            <ngx-skeleton-loader class="h-10" [theme]="{ width: '100%', height: '40px', borderRadius: '6px' }"></ngx-skeleton-loader>
          </div>
        }
      </div>
    } @else {
      @for (customFieldKey of [selectedSystemUniqueId + '-' + customFieldsRefreshTick()]; track customFieldKey) {
        <svc-form-custom-field
          svcTestId="ap-form__section--custom-fields"
          class="col-span-full"
          #customField
          [applicationId]="applicationId"
          [featureId]="customFieldsFeatureId"
          [registryId]="selectedSystemTemplateId ?? undefined"
          [onlyCustomFields]="!selectedSystemTemplateId"
          [systemReferenceId]="actionPlanUniqueId ?? undefined"
          [isViewMode]="!isAddMode && !isEditMode"
        ></svc-form-custom-field>
      }
    }
  }

  @for (dateFieldsKey of [dateFieldsRefreshTick()]; track dateFieldsKey) {
    <svc-highlight-group svcTestId="ap-form__section--dates" class="col-span-full action-plan-date-group">
      <svc-date-picker
        svcTestId="ap-form__input--creation-date"
        class="w-full"
        inputId="action-plan-register-form-creation-date"
        formControlName="creationDate"
        [label]="'Data de criação' | transloco"
        [showIcon]="false"
      ></svc-date-picker>

      <svc-date-picker
        svcTestId="ap-form__input--due-date"
        class="w-full"
        inputId="action-plan-register-form-due-date"
        formControlName="dueDate"
        [label]="'Data prevista' | transloco"
        [min]="dueDateMin"
        [showIcon]="false"
      ></svc-date-picker>

      <svc-text
        svcTestId="ap-form__input--approval-date"
        class="w-full"
        inputId="action-plan-register-form-approval-date"
        formControlName="approvalDateText"
        [label]="'Data de aprovação' | transloco"
      ></svc-text>

      <svc-text
        svcTestId="ap-form__input--conclusion-date"
        class="w-full"
        inputId="action-plan-register-form-conclusion-date"
        formControlName="conclusionDateText"
        [label]="'Data de conclusão' | transloco"
      ></svc-text>
    </svc-highlight-group>
  }
</form>

